import React from "react";
import { useEffect, useState, useRef } from "react";

function Timer({ onTick }) {
    const [elapsed, setElapsed] = useState(0);
    const lastStartRef = useRef(null);
    const intervalRef = useRef(null);

    useEffect(() => {
        function startTimer() {
            if (lastStartRef.current === null) {
                lastStartRef.current = Date.now();
            }

            intervalRef.current = setInterval(() => {
                const now = Date.now();
                const diff = Math.floor((now - lastStartRef.current) / 1000);

                setElapsed(prev => {
                    const newVal = prev + diff;
                    if (onTick) onTick(newVal); // send value to parent
                    return newVal;
                });

                lastStartRef.current = now;
            }, 1000);
        }

        function stopTimer() {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            lastStartRef.current = null;
        }

        function handleVisibility() {
            if (document.hidden) {
                stopTimer();   // pause when tab hidden
            } else {
                startTimer();  // resume when visible
            }
        }

        // Start initially
        startTimer();

        document.addEventListener("visibilitychange", handleVisibility);

        return () => {
            clearInterval(intervalRef.current);
            document.removeEventListener("visibilitychange", handleVisibility);
        };
    }, [onTick]);

    return <div></div>;
}

export default Timer;